import '.ak{position:relative;}.ssr-plugin'
import '.jj{width:64px;}.ssr-plugin'
import '.jk{height:64px;}.ssr-plugin'
import '.ac{flex-shrink:0;}.ssr-plugin'
import '.b8{position:absolute;}.ssr-plugin'
import '.jl{bottom:-4px;}.ssr-plugin'
import '.hu{right:-4px;}.ssr-plugin'
import '.g4{border-radius:50%;}.ssr-plugin'
import '.cf{border:2px solid var(--palette-white);}.ssr-plugin'
import '.bv{overflow:hidden;}.ssr-plugin'
import '.jm{width:32px;}.ssr-plugin'
import '.jn{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ak jj jk ac"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="b8 jl hu g4 cf bv jm jn"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
